import { atom } from "jotai";

import {
  VerificationModalStepStateAtom,
  defaultVerificationModalStepState,
} from "../../stores";

export const GoBackToPreviousStepAtom = atom(
  null,
  (get, set, props?: { emailOrPhone?: string }) => {
    const state = get(VerificationModalStepStateAtom);
    const backStep = state.backStep;
    if (backStep) {
      switch (backStep) {
        case "Initial":
          set(
            VerificationModalStepStateAtom,
            defaultVerificationModalStepState
          );
          break;
        case "ClubSelection":
          set(VerificationModalStepStateAtom, {
            step: "ClubSelection",
            backStep: "Initial",
            emailOrPhone: props?.emailOrPhone ?? "",
          });
          break;
        default:
          set(
            VerificationModalStepStateAtom,
            defaultVerificationModalStepState
          );
      }
    }
  }
);
